import React from 'react';
import { graphql } from 'gatsby';
import Seo from '../components/site/Seo';
import { SupportUsExamples } from '../components/pages/SupportUs';
import { Hero, Content, Container } from '../components/ui';
import useCollectionData from '../hooks/useCollectionData';
import type Directus from '../types/directus';
import type Page from '../types/page';

export interface ISupportUsPageProps {
  support_us: {
    id: string;
    date_updated: string;
    title: string;
    intro?: string;
    content?: string;
    translations: Directus.Translations<{
      title: string;
      intro?: string;
      content?: string;
    }>;
  };
}

type PageData = Directus.Query<ISupportUsPageProps>;

const SupportUsPage: Page.Component<PageData> = ({ data }) => {
  const { title, intro, content } = useCollectionData(
    data.directus.support_us
  );

  return (
    <>
      <Hero title={title} subtitle={intro} />
      {content && <Content source={content} />}
      <Container width="full">
        <SupportUsExamples />
      </Container>
    </>
  );
};

export default SupportUsPage;

export const Head: Page.Head<PageData> = ({ data, pageContext }) => {
  const { title, intro } = useCollectionData(
    data.directus.support_us,
    pageContext.language
  );

  return (
    <Seo
      lang={pageContext.language}
      title={title}
      description={intro}
    />
  );
};

export const query = graphql`
  query SupportUsPageData($language: String!) {
    directus {
      support_us {
        id
        date_updated
        title
        intro
        content
        translations(
          filter: { languages_code: { code: { _eq: $language } } }
        ) {
          languages_code {
            code
          }
          title
          intro
          content
        }
      }
    }
  }
`;
